/**
 * Auth email callback origins — always HTTPS production host (Safari / browser).
 * Confirm + reset are not Universal Links; do not use capacitor:// or movieme:// in emails.
 */
const raw =
  import.meta.env.VITE_AUTH_CALLBACK_ORIGIN ||
  import.meta.env.VITE_SITE_URL ||
  'https://www.moviemeapp.com';

export const AUTH_CALLBACK_ORIGIN = String(raw).replace(/\/$/, '');

export function emailConfirmedUrl(): string {
  return `${AUTH_CALLBACK_ORIGIN}/email-confirmed`;
}

export function resetPasswordUrl(): string {
  return `${AUTH_CALLBACK_ORIGIN}/reset-password`;
}

/** Support contact used on Account screen (public). */
export const SUPPORT_EMAIL = 'info@moviemeapp.com';
